@for (answer of answers(); track trackByAnswer($index, answer); let lastAnswer = $last) {
  @if (hasAnswers(answer) || isSection(answer.questionKind) || answer.noteJson) {
    <div
      avoid-page-break
      [attr.margin-bottom-large]="!lastAnswer && !isSection(answer.questionKind) ? '' : null"
    >
      @if (isSection(answer.questionKind)) {
        <rt-heading variant="heading large block" class="section-title" margin-bottom-small-x>
          {{ answer.questionTitle }}
        </rt-heading>
      }

      @if (isSimple(answer.questionKind)) {
        <rt-heading>{{ answer.questionTitle }}</rt-heading>
        @let safeContent = getSafeContent(answer);
        @if (safeContent) {
          <div class="simple-answer-content" [innerHTML]="safeContent"></div>
        } @else {
          <div class="simple-answer-content">{{ answer.content }}</div>
        }
      }

      @if (isBoolean(answer.questionKind)) {
        <rt-heading>{{ answer.questionTitle }}</rt-heading>
        <div class="simple-answer-content">
          {{ getBooleanAnswer(answer.content) }}
        </div>
      }

      @if (isDate(answer.questionKind)) {
        <rt-heading>{{ answer.questionTitle }}</rt-heading>
        <div class="simple-answer-content">{{ getFormattedDate(answer.content) }}</div>
      }

      @if (isSalary(answer.questionKind)) {
        <rt-heading>{{ answer.questionTitle }}</rt-heading>
        <div class="simple-answer-content">{{ getSalary(answer) }}</div>
      }

      @if (isMultiChoice(answer.questionKind)) {
        <rt-heading>{{ answer.questionTitle }}</rt-heading>
        <div layout layout-full-width>
          <div layout layout-vertical>
            @for (content of answer.contents; track trackByContent($index, content)) {
              <div layout layout-align-items-center class="multi-choice-item">
                @if (content) {
                  <rt-icon name="check" size="small" />
                  {{ content }}
                }
              </div>
            }
          </div>
        </div>
      }

      @if (isScorecard(answer.questionKind)) {
        <rt-heading>{{ answer.questionTitle }}</rt-heading>
        <rt-box variant="default vertical no-padding" margin-top-small>
          <div class="box-body">
            @for (
              option of filterEmptyOptions(answer);
              track trackByOption(i, option);
              let lastOption = $last;
              let i = $index
            ) {
              <div layout-horizontal layout-align-items-center padding-lr padding-tb-small>
                <div layout-vertical layout-flex-1>
                  <rt-heading class="subheading" margin-bottom-small-x>
                    {{ option.title }}
                  </rt-heading>
                </div>
                <rt-interview-evaluation-rating
                  [rating]="filterEmptyContents(answer.contents!)[i]"
                  [translations]="ratingLevelTranslations()"
                  variant="hasLabel"
                />
              </div>
              @if (!lastOption) {
                <rt-divider />
              }
            }
          </div>
        </rt-box>
      }

      @if (isSkills(answer.questionKind)) {
        @let skills = getEvaluatedSkills(answer);
        @if (skills.length) {
          <rt-heading>{{ translations.skillsHeading }}</rt-heading>
          <rt-box
            variant="no-padding"
            layout-vertical
            padding-tb-small
            padding-lr-medium
            margin-top-small
          >
            @for (skill of skills; track skill.id; let lastSkill = $last) {
              @let proficiencyId =
                $safeNavigationMigration((answer.skillRatings || []).find(
              (rating) => rating.skillId === skill.id
            )?.proficiencyId);
              @let selectedProficiency =
                skill.proficiencies.find(
              (proficiency) => proficiency.id === proficiencyId
            );
              <div layout layout-full-width>
                <div layout layout-flex-1 layout-align-items-start layout-space-between>
                  <span
                    [rtTooltip]="skill.name"
                    [rtTooltipEnableWhenTruncated]="true"
                    class="one-line"
                    text-bold
                    text-darkest
                    >{{ skill.name }}</span
                  >
                </div>
                <div layout-vertical layout-align-items-end>
                  <div layout class="skill-levels" margin-left-small margin-top-small-xx>
                    @for (proficiency of skill.proficiencies; track proficiency.id) {
                      <span
                        class="skill-leaf"
                        [class.filled]="
                          proficiency.position <= (selectedProficiency?.position || 0)
                        "
                      ></span>
                    }
                  </div>
                  <div layout layout-align-items-end layout-justify-flex-end>
                    <div
                      [rtTooltip]="$safeNavigationMigration(selectedProficiency?.name)"
                      [rtTooltipEnableWhenTruncated]="true"
                      class="skill-proficiency one-line"
                      margin-left-small
                    >
                      <span text-darkest>{{ selectedProficiency?.name }}</span>
                    </div>
                  </div>
                </div>
              </div>

              @if (!lastSkill) {
                <rt-divider margin-tb-small />
              }
            }
          </rt-box>
        }
      }

      @if (isFile(answer.questionKind)) {
        <rt-heading>{{ answer.questionTitle }}</rt-heading>
        <div layout margin-top-small>
          <rt-attachments-list
            [attachments]="getAttachments(answer)"
            [canManageCandidates]="canManageCandidates()"
            [small]="true"
          />
          @if (answer.attachments?.length !== 0) {
            <span class="print-attachments">{{ translations.attachment }}</span>
          }
        </div>
      }

      @if (useProsemirror() && answer.noteJson) {
        <div
          class="answer-note"
          prosemirrorDefaultConfig
          [prosemirrorRender]="answer.noteJson"
          [prosemirrorRenderConfig]="ProsemirrorConfig"
        ></div>
      }
    </div>
  }
}

@if (score() || safeRatingNote()) {
  <div class="evaluation-score" [attr.margin-top-large]="answers().length ? '' : null">
    <rt-heading>
      {{ 'app.evaluation_tab.form_details.reviewer_result.evaluation_score' | translate }}
    </rt-heading>
    @if (ratingScale(); as scale) {
      @if (score()) {
        <rt-evaluation-rating-score
          [evaluationScale]="scale"
          [score]="score()"
          [showIcon]="showScoreIcon()"
          iconSize="small"
          fontSize="default"
        />
      }
    }
    @if (safeRatingNote(); as note) {
      <div class="rating-note" [innerHTML]="note"></div>
    }
  </div>
}
